interface StatsCardProps {
  label: string;
  value: string | number;
  subLabel?: string;
  icon: string;
  iconColor?: string;
}

export default function StatsCard({ label, value, subLabel, icon, iconColor = '#234638' }: StatsCardProps) {
  return (
    <div className="rounded-md border px-2.5 py-2 flex items-center gap-2 min-h-[70px]" style={{ backgroundColor: '#FFFEFA', borderColor: '#DED9CC' }}>
      <div className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F0EDE5' }}>
        <i className={`${icon} text-base`} style={{ color: iconColor }}></i>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[10px] leading-tight mb-0.5" style={{ color: '#6B6B67' }}>{label}</p>
        <p className="text-lg leading-none font-bold" style={{ color: '#234638' }}>{value}</p>
        {subLabel && (
          <p className="text-[9px] mt-1 truncate" style={{ color: '#6B6B67' }}>{subLabel}</p>
        )}
      </div>
    </div>
  );
}
